module.exports = __webpack_public_path__ + "img/6.05a4ab08.png";